<div class="grid min-h-full grid-cols-1 grid-rows-[1fr,auto,1fr] bg-white lg:grid-cols-[max(50%,36rem),1fr] flex-1">
    <header class="mx-auto w-full max-w-7xl px-6 pt-6 sm:pt-10 lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:px-8">
        <a href="#">
            <span class="sr-only">Your Company</span>
            <img
                class="h-7 w-auto"
                src="/assets/logo/blue_black/ares_logo_blue_black@2x.png"
                alt="ARES"
                height="158"
                width="458"
            >

        </a>
    </header>
    <main class="mx-auto w-full max-w-7xl px-6 py-24 sm:py-32 lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:px-8">
        <div class="max-w-lg">
            <p class="text-base font-semibold leading-8 text-blue-600">
                Organisatie niet gevonden
            </p>
            <h1 class="mt-4 text-3xl font-header tracking-tight text-gray-900 sm:text-5xl" i18n="@@component.organization-not-found.text">
                Selecteer een organisatie
            </h1>
            <p class="mt-6 text-base leading-7 text-gray-600">
                We kunnen de organisatie die je zoekt niet vinden op basis van de URL.
            </p>
            <div class="mt-10">
                @if (isAuthenticated()) {
                    <div>
                        <div class="text-md">
                            Selecteer een organisatie om verder te gaan
                        </div>
                        <div class="mt-5">
                            <app-organization-picker />
                        </div>
                    </div>
                } @else {
                    <button
                        app-button
                        variant="primary"
                        size="md"
                        full
                        (click)="login()"
                    >
                        Log in om organisaties te zien
                        <span class="ml-2" aria-hidden="true">&rarr;</span>
                    </button>
                }
            </div>
        </div>
    </main>
    <footer class="self-end lg:col-span-2 lg:col-start-1 lg:row-start-3">
        <div class="border-t border-gray-100 bg-gray-50 py-10">
            <nav class="mx-auto flex w-full max-w-7xl items-center gap-x-4 px-6 text-sm leading-7 text-gray-600 lg:px-8">
                <a class="hover:underline" href="#">Contact support</a>
                <svg viewBox="0 0 2 2" aria-hidden="true" class="h-0.5 w-0.5 fill-gray-300">
                    <circle cx="1" cy="1" r="1" />
                </svg>
                <span class="text-gray-400">© {{ currentYear }} - ARES Capital</span>
                <svg viewBox="0 0 2 2" aria-hidden="true" class="h-0.5 w-0.5 fill-gray-300">
                    <circle cx="1" cy="1" r="1" />
                </svg>
                <span class="text-gray-400">App version {{ gitVersion.hash }}</span>
            </nav>
        </div>
    </footer>
    <div class="hidden lg:relative lg:col-start-2 lg:row-start-1 lg:row-end-4 lg:block">
        <img src="/assets/images/austin-distel-1-unsplash.jpg" alt="" class="absolute inset-0 h-full w-full object-cover">
    </div>
</div>
